// @flow
import React from 'react';
import { Link } from 'react-router';
import CapacitorRipple from '../capacitor/Ripple';
import IconLabel from '../util/IconLabel';
import RecordingTags from './RecordingTags';
import TrackCount from '../messages/TrackCount';
import FormattedTime from '../util/FormattedTime';
import styles from './RecordingItem.css';
import getRecordingIsPopular from '../../utils/getRecordingIsPopular';
import type { Recording } from '../../shapes/types';
import ComposerList from '../common/ComposerList';
import shouldOmitForenameFromComposers from '../../utils/shouldOmitForenameFromComposers';
import TitleWithPopularTitle from '../common/TitleWithPopularTitle';
import RecordingDate from './RecordingDate';
import Separated from '../util/Separated';
type Props = {
  recording: Recording,
  hideWorkTitle?: boolean,
};

const RecordingItemLink = ({ recording, hideWorkTitle }: Props) => {
  const { id, summary, recordingDate, tags, work, tracksCount, duration } = recording;

  return (
    <Link className={styles.link} to={`/recordings/${id}`} data-test="recording-item.link">
      <CapacitorRipple />
      <div className={styles.infoContainer} data-test="recording-item.info">
        {!hideWorkTitle && (
          <React.Fragment>
            <div className={styles.composer}>
              <ComposerList
                authors={work.authors}
                omitForename={shouldOmitForenameFromComposers(work.authors)}
              />
            </div>
            <div className={styles.title}>
              <TitleWithPopularTitle {...work} />
            </div>
          </React.Fragment>
        )}
        <div className={hideWorkTitle ? styles.title : styles.summary}>
          <span>{summary}</span>
        </div>
        <div className={styles.info}>
          <Separated>
            <RecordingDate recordingDate={recordingDate} />
            {tracksCount && <TrackCount trackCount={tracksCount} />}
            {duration && <FormattedTime>{duration}</FormattedTime>}
          </Separated>
        </div>
        {tags && (
          <div className={styles.tags}>
            <RecordingTags tags={tags} isPopular={getRecordingIsPopular(recording)} />
          </div>
        )}
      </div>
      <IconLabel name="chevron-right" className={styles.linkIcon} size="medium" />
    </Link>
  );
};

export default RecordingItemLink;
